<template>
    <x-modal
        :wWidth="1080"
        v-if="visible"
        @cancel="closeModal"
        @close="closeModal"
        @ok="saveBrokerTarget"
        :draggable="true"
        :resizable="true"
        :loading="loading"
        :okDisabled="loading || disableBtn"
        :okText="'Save'">
        <div slot="title" :class="`d-flex justify-content-between align-items-center`">
            Broker Target
        </div>

        <div class="mb-2 d-flex justify-content-end">
            <el-button @click="addBrokerTarget"><i class="fas fa-plus"></i> Add</el-button>
        </div>

        <div class="my-3">
            <el-table
                :data="brokerTarget"
                fit
                style="width: 100%">
                <el-table-column
                    prop="broker_id"
                    label="Brokers"
                    width="180">
                    <template slot-scope="scope">
                        <el-select class="w-100" v-model="scope.row.broker_id" placeholder="Broker ID" clearable
                                   @change="checkBrokerAlreadySelected">
                            <el-option
                                v-for="scoreOption in brokers"
                                :key="scoreOption.id"
                                :label="_.get(scoreOption, 'full_name', '')"
                                :value="scoreOption.id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="no_of_settlements"
                    label="Number of Settlements"
                    width="200">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.no_of_settlements"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="total_income"
                    label="Total Income"
                    width="200">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.total_income"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="insurance_penetration"
                    label="Insurance Penetration"
                    width="200">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.insurance_penetration"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="avg_income"
                    label="Average Income"
                    width="200">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.avg_income"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="lead_to_application"
                    label="Lead To Application"
                    width="180">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.lead_to_application"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="lead_to_settlement"
                    label="Lead To Settlement"
                    width="180">
                    <template slot-scope="scope">
                        <el-input-number class="w-100" v-model="scope.row.lead_to_settlement"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Action">
                    <template slot-scope="scope">
                        <a @click="remove(scope.$index, scope.row)"><i class="fas fa-times-circle text-danger ml-3"></i></a>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-alert
            v-if="disableBtn"
            :title="disableBtnText"
            type="error">
        </el-alert>
    </x-modal>
</template>

<script>

export default {
    name: 'BrokerTargetIndex',
    props: [
        'visible'
    ],
    data() {
        return {
            loading: false,
            previousBrokerTargets: [],
            brokerTarget: [],
            brokers: [],
            disableBtnText: '',
            disableBtn: false
        }
    },
    mounted() {
        this.getBrokerTarget()

        this.disableBtn = false
    },
    computed: {},
    methods: {
        closeModal() {
            this.$emit('update:visible', false)
            this.$bus.$emit('reload::broker::target')
        },
        addBrokerTarget() {
            this.brokerTarget.push({
                broker_id: null,
                no_of_settlements: null,
                total_income: null,
                insurance_penetration: null,
                avg_income: null,
                lead_to_application: null,
                lead_to_settlement: null
            })
        },
        remove(i, v) {
            const index = this.brokerTarget.indexOf(v);

            const removedBrokerTarget = _.get(this.brokerTarget, index)

            this.$tenant.post(`/api/v3/broker-target/delete/${_.get(removedBrokerTarget, 'id')}`)
                .then((res) => {
                    swal({
                        title: "Success!",
                        type: "success",
                        text: `Broker target Deleted`
                    })

                    this.getBrokerTarget()
                    this.loading = false
                }).catch((error) => {
                swal({
                    title: "Error!",
                    type: "error",
                    text: `Error saving target \n ` + _.get(error, 'response', '')
                })

                this.loading = false
            })
        },
        getBrokerTarget() {
            this.$tenant.get('/api/v3/broker-target/index').then((res) => {
                this.brokers = _.get(res.data, 'brokers', [])
                this.brokerTarget = _.get(res.data, 'brokerTargets', [])

                this.previousBrokerTargets = this.brokerTarget

                if (_.isEmpty(_.get(res.data, 'brokerTargets'))) {
                    this.brokerTarget.push({
                        broker_id: null,
                        no_of_settlements: null,
                        total_income: null,
                        insurance_penetration: null,
                        avg_income: null,
                        lead_to_application: null,
                        lead_to_settlement: null
                    })
                }
            }).catch((error) => {
                console.log('getBrokerTarget Error ', _.get(error, 'response', ''))
            })
        },
        saveBrokerTarget() {
            this.loading = true

            this.$tenant.post('/api/v3/broker-target/save', {'brokersTarget': this.brokerTarget}).then((res) => {
                swal({
                    title: "Success!",
                    type: "success",
                    text: `Broker target saved`
                })

                this.loading = false
                this.closeModal()
            }).catch((error) => {
                swal({
                    title: "Error!",
                    type: "error",
                    text: `Error saving target \n ` + _.get(error, 'response', '')
                })

                this.loading = false
            })
        },
        checkBrokerAlreadySelected(val) {
            if (_.size(this.brokerTarget) > 1 && _.find(this.brokerTarget.slice(0, -1), {broker_id: val})) {
                this.disableBtn = true
                this.disableBtnText = 'Broker already selected!!'
            } else if (_.size(this.brokerTarget) > 1 && !_.find(this.brokerTarget.slice(0, -1), {broker_id: val})) {
                this.disableBtn = false
                this.disableBtnText = ''
            }
        }
    },
    watch: {}
}
</script>
